export enum SeoFragment {
	Organization = "organization",
	Website = "website",
	ReturnPolicyPerishable = "return-policy-perishable",
	ReturnPolicyStandard = "return-policy-standard",
}
